import { get } from 'lodash';

import { SUPPORTED_LOCALES } from 'constants/locales';
import Model from 'models';
import Settings from 'utils/Settings';

const CustomCollectionModel = class extends Model {
  get name() {
    return get(this._data, ['localizedName', Settings.currentLocale]);
  }

  get description() {
    return get(this._data, ['localizedDescription', Settings.currentLocale]);
  }

  get image() {
    return get(this._data, ['localizedImage', Settings.currentLocale]);
  }

  get bannerBgColor() {
    return get(this._data, 'bannerBgColor');
  }

  get productsSortOrder() {
    return get(this._data, 'productsSortOrder');
  }

  get isLoading() {
    return get(this._data, 'isLoading');
  }

  get faqHeading() {
    return get(this._data, ['localizedFaqHeading', Settings.currentLocale]);
  }

  get faqItems() {
    return get(this._data, ['faqItems', SUPPORTED_LOCALES.EN_US]);
  }

  get condensedImage() {
    return get(this._data, ['localizedCondensedImage', Settings.currentLocale]);
  }

  get fullBleedImageDesktop() {
    return get(this._data, ['localizedFullBleedImageDesktop', Settings.currentLocale]);
  }

  get fullBleedImageMobile() {
    return get(this._data, ['localizedFullBleedImageMobile', Settings.currentLocale]);
  }

  get supportingText() {
    return get(this._data, ['localizedSupportingText', Settings.currentLocale]);
  }

  get fullBleedAlignmentDesktop() {
    return get(this._data, ['localizedFullBleedAlignmentDesktop', Settings.currentLocale]);
  }

  get fullBleedAlignmentMobile() {
    return get(this._data, ['localizedFullBleedAlignmentMobile', Settings.currentLocale]);
  }

  get descriptionModule() {
    return get(this._data, ['localizedDescriptionModule', Settings.currentLocale]);
  }
};

export default CustomCollectionModel;
